<template>
    <div>
        <section id="tagline_v2" class="s-tagline">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <p class="cell auto">みんなの共感をパワーに、創造的なプロジェクトを実現するクラウドファンディング「MotionGallery」</p>

                    <nav class="cell shrink">
                        <ul>
                            <li><a href="https://motion-gallery.net/about">MotionGallery について</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
        <header id="header_v2" class="s-header nav_menu--container">
            <div class="grid-container">
                <div class="grid-x grid-padding-x">
                    <div class="cell">
                        <h1 id="h-logo"><a href="https://motion-gallery.net/"><img src="https://motion-gallery.net/images/logo.png" alt="Motion Gallery"></a></h1>
                        <nav>
                            <ul class="header-nav">
                                <li class="nav_menu--holder">
                                    <a href="https://motion-gallery.net/discover">プロジェクトを探す</a>
                                    <nav-menu />
                                </li>
                                <li><a href="https://motion-gallery.net/start_project">プロジェクトを始める</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import NavMenu from '~/components/atoms/NavMenu'
export default {
    name: 'HeaderTag',
    components: { NavMenu },
    data: () => ({
    })
}
</script>
